import { useContext, useMemo } from 'react';

import { StockBuySellContext } from '@context/stock/buysell';

const useStockBuySellContext = () => {
  const {
    activeCode: code,
    formState: _formState,
    formKey,
    ...restContext
  } = useContext(StockBuySellContext);
  const formState = useMemo(() => _formState[code] ?? {}, [_formState, code]);

  const isCreate = formState[formKey.CONST_FORM_TYPE] === 'CREATE';
  const isAmend = formState[formKey.CONST_FORM_TYPE] === 'AMEND';
  const isAmendExpired = isAmend && formState[formKey.CONST_STATUS] === 'EXPIRED';

  const isBuy = formState[formKey.INPUT_ORDER_SIDE] === 'BUY';
  const isSell = formState[formKey.INPUT_ORDER_SIDE] === 'SELL';

  const isAccountRegular = formState[formKey.INPUT_ACCOUNT_TYPE]?.value === 'REGULAR';
  const isAccountDT = formState[formKey.INPUT_ACCOUNT_TYPE]?.value === 'DAY_TRADING';
  const isAccountMT = formState[formKey.INPUT_ACCOUNT_TYPE]?.value === 'MARGIN_TRADING';

  const isLimitOrder = formState[formKey.TAB_ORDER_TYPE]?.key === 'LIMIT';
  const isAutoOrder = formState[formKey.TAB_ORDER_TYPE]?.key === 'AUTO';

  const { maxBuy, maxSell } = useMemo(() => {
    switch (formState[formKey.INPUT_ACCOUNT_TYPE]?.value) {
      case 'REGULAR':
        return {
          maxBuy: {
            value: formState[formKey.CONST_MAX_BUY],
            label: formState[formKey.CONST_MAX_BUY_LABEL],
          },
          maxSell: {
            value: formState[formKey.CONST_MAX_SELL],
            label: formState[formKey.CONST_MAX_SELL],
          },
        };
      case 'DAY_TRADING':
        return {
          maxBuy: {
            value: formState[formKey.CONST_MAX_BUY_DT],
            label: formState[formKey.CONST_MAX_BUY_LABEL_DT],
          },
          maxSell: {
            value: formState[formKey.CONST_MAX_SELL_DT],
            label: formState[formKey.CONST_MAX_SELL_DT],
          },
        };
      case 'MARGIN_TRADING':
        return {
          maxBuy: {
            value: formState[formKey.CONST_MAX_BUY_MT],
            label: formState[formKey.CONST_MAX_BUY_LABEL_MT],
          },
          maxSell: {
            value: formState[formKey.CONST_MAX_SELL_MT],
            label: formState[formKey.CONST_MAX_SELL_MT],
          },
        };
      default:
        return {
          maxBuy: { value: 0, label: 0 },
          maxSell: { value: 0, label: 0 },
        };
    }
  }, [formState]);

  return {
    code,
    formState,
    formKey,
    ...restContext,
    isCreate,
    isAmend,
    isAmendExpired,
    isBuy,
    isSell,
    isAccountRegular,
    isAccountDT,
    isAccountMT,
    isLimitOrder,
    isAutoOrder,
    maxBuy,
    maxSell,
  };
};

export default useStockBuySellContext;
